import './MyNavbar.css'

import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { NavLink } from 'react-router-dom';


function MyNavbar() {
  const expand = 'md'
    return(
      // use offcanvasNavbar for MyNavbar component from react-bootstrap
         <Navbar key={expand} style={{backgroundColor : '#d2d2d2ff'}} expand={expand} className="">
          <Container>
            {/* here in bleow line use vidaloka font for navbar brand */}
            <Navbar.Brand className='vidalokaFont fs-3' href="#">Udemy Blog</Navbar.Brand>
            <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-${expand}`} />
            <Navbar.Offcanvas
              id={`offcanvasNavbar-expand-${expand}`}
              aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
              placement="start"
            >
              <Offcanvas.Header closeButton>
                <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${expand}`}>
                  Udemy Blog
                </Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                <Nav className="justify-content-end flex-grow-1 pe-3">
                  <NavLink className= 'nav-link' to= '/'>Main page</NavLink>
                  <NavLink className= 'nav-link' to= '/add-article'>Add article</NavLink>
                  <NavLink className= 'nav-link' to= '/articles'>Articles</NavLink>
                  <NavLink className= 'nav-link' to= '/courses'>Courses</NavLink>
                  <NavLink className= 'nav-link' to= '/about'>About us</NavLink>
                </Nav>
              </Offcanvas.Body>
            </Navbar.Offcanvas>
          </Container>
        </Navbar>
    )
}

export default MyNavbar